module.exports = __webpack_public_path__ + "@/assets/img/mercadopagologo.9a790a62.png";